<template>
  <el-input
    v-bind="$attrs"
    v-model="value"
    v-on="$listeners"
    :formatter="(value:string) => bankNoFormatter(value)"
    :parser="(value:string) => bankNoParser(value)"
  />
</template>
<script lang="ts" setup>
  import { computed, onMounted } from 'vue'
  /**
   * 配置属性
   */
  interface IYfBankNoInputProps {
    modelValue: string | number
  }
  /**
   * 自定义事件
   */
  interface IYfBankNoInputEmits {
    (e: 'update:modelValue', value: string | number): void
  }
  const props = defineProps<IYfBankNoInputProps>()
  const emit = defineEmits<IYfBankNoInputEmits>()
  const value = computed<string | number>({
    get: () => props.modelValue,
    set: (val: string | number) => emit('update:modelValue', val)
  })
  function bankNoFormatter(value: string) {
    return value
      .replace(/\s/g, '')
      .replace(/(.{4})/g, '$1 ')
      .trim()
  }
  function bankNoParser(value: string) {
    return value.replace(/\s/g, '')
  }
</script>
